import { Img } from "@/components/ui/image"
import { AppChannel, Channel } from "@/config/channel"

export function SisalLogo({ channel }: { channel?: Channel }) {
  if (channel === AppChannel.AppCasinoHub)
    return (
      <Img
        src="/assets/logo/logo-sisal-55.svg"
        alt="logo"
        width={81}
        height={28}
      />
    )

  return (
    <Img src="/assets/logo/logo-sisal.svg" alt="logo" width={114} height={28} />
  )
}
